// This file is auto-generated
// Please do not edit it directly import the files from figma design tokens (https://www.notion.so/timeedit/Figma-Design-Tokens-1ff63cb4d48f4aeea55df6b7dcb9e7fa) and run the parseDesignTokens.mjs script to generate it.
// Colors
export const geekblue1 = "#E1FFF2";
export const geekblue2 = "#9DFFDD";
export const geekblue3 = "#8BF7B8";
export const geekblue4 = "#35DE87";
export const geekblue5 = "#06A95F";
export const geekblue6 = "#00824C";
export const geekblue7 = "#005C39";
export const geekblue8 = "#003623";
export const geekblue9 = "#00120C";
export const geekblue10 = "#000000";
export const purple1 = "#FAF0FF";
export const purple2 = "#EED1FF";
export const purple3 = "#DCA8FF";
export const purple4 = "#C880FF";
export const purple5 = "#AF56FC";
export const purple6 = "#8F2CEF";
export const purple7 = "#6C1AC9";
export const purple8 = "#4E0DA3";
export const purple9 = "#34047D";
export const purple10 = "#210257";
export const cyan1 = "#E6FFFB";
export const cyan2 = "#B0FFF6";
export const cyan3 = "#84FAF0";
export const cyan4 = "#58EDE6";
export const cyan5 = "#2FE0DD";
export const cyan6 = "#0BD1D3";
export const cyan7 = "#00A5AD";
export const cyan8 = "#007C87";
export const cyan9 = "#005661";
export const cyan10 = "#00323B";
export const green1 = "#DFFFEA";
export const green2 = "#A9F3C5";
export const green3 = "#7ADEA4";
export const green4 = "#53CF8A";
export const green5 = "#2ABF72";
export const green6 = "#08AA5C";
export const green7 = "#008549";
export const green8 = "#005E37";
export const green9 = "#003823";
export const green10 = "#00120C";
export const magenta1 = "#fff0f6";
export const magenta2 = "#ffd6e7";
export const magenta3 = "#ffadd2";
export const magenta4 = "#ff85c0";
export const magenta5 = "#f759ab";
export const magenta6 = "#eb2f96";
export const magenta7 = "#c41d7f";
export const magenta8 = "#9e1068";
export const magenta9 = "#780650";
export const magenta10 = "#520339";
export const red1 = "#FFF4F0";
export const red2 = "#FFDED4";
export const red3 = "#FFBDAB";
export const red4 = "#FF9982";
export const red5 = "#FF7259";
export const red6 = "#F5462F";
export const red7 = "#CF2C1D";
export const red8 = "#A8170F";
export const red9 = "#820705";
export const red10 = "#5C0304";
export const orange1 = "#fff7e6";
export const orange2 = "#ffe7ba";
export const orange3 = "#ffd591";
export const orange4 = "#ffc069";
export const orange5 = "#ffa940";
export const orange6 = "#fa8c16";
export const orange7 = "#d46b08";
export const orange8 = "#ad4e00";
export const orange9 = "#873800";
export const orange10 = "#612500";
export const yellow1 = "#FFFFE6";
export const yellow2 = "#FFFCAB";
export const yellow3 = "#FFF782";
export const yellow4 = "#FFEE59";
export const yellow5 = "#FFE330";
export const yellow6 = "#FBD408";
export const yellow7 = "#D4A900";
export const yellow8 = "#AD8500";
export const yellow9 = "#876300";
export const yellow10 = "#614400";
export const volcano1 = "#fff2e8";
export const volcano2 = "#ffd8bf";
export const volcano3 = "#ffbb96";
export const volcano4 = "#ff9c6e";
export const volcano5 = "#ff7a45";
export const volcano6 = "#fa541c";
export const volcano7 = "#d4380d";
export const volcano8 = "#ad2102";
export const volcano9 = "#871400";
export const volcano10 = "#610b00";
export const blue1 = "#F0F4FF";
export const blue2 = "#C9D6FF";
export const blue3 = "#A1B4FF";
export const blue4 = "#788EFF";
export const blue5 = "#4F67FF";
export const blue6 = "#263CFF";
export const blue7 = "#1623D9";
export const blue8 = "#090FB3";
export const blue9 = "#00008C";
export const blue10 = "#030066";
export const lime1 = "#fcffe6";
export const lime2 = "#f4ffb8";
export const lime3 = "#eaff8f";
export const lime4 = "#d3f261";
export const lime5 = "#bae637";
export const lime6 = "#a0d911";
export const lime7 = "#7cb305";
export const lime8 = "#5b8c00";
export const lime9 = "#3f6600";
export const lime10 = "#254000";
export const gold1 = "#FFFDF0";
export const gold2 = "#FFF4BA";
export const gold3 = "#FFE991";
export const gold4 = "#FFDC69";
export const gold5 = "#FFCC40";
export const gold6 = "#FFB916";
export const gold7 = "#D99309";
export const gold8 = "#B37100";
export const gold9 = "#8C5400";
export const gold10 = "#663A00";
// Base
/** IMPORTANT: If used, make sure to transform it to rem */
export const baseFontSizeInPx = 16;
// Seed
export const colorTextBase = "#000000";
export const colorTextLightSolid = "#ffffff";
export const colorBgBase = "#ffffff";
export const fontFamily = "'Source Sans 3', sans-serif";
/** IMPORTANT: If used, make sure to transform it to rem */
export const fontSize = 14;
export const lineWidth = 1;
export const borderRadius = 6;
export const sizeUnit = 4;
export const sizePopupArrow = 16;
export const controlHeight = 32;
export const opacityImage = 1;
export const sizeStep = 4;
export const colorPrimary = geekblue6;
export const colorError = red7;
export const colorWarning = yellow6;
export const colorSuccess = green6;
export const colorInfo = blue6;
// Map
export const sizeXXL = sizeUnit * (sizeStep + 8);
export const sizeXL = sizeUnit * (sizeStep + 4);
export const sizeLG = sizeUnit * (sizeStep + 2);
export const sizeMD = sizeUnit * (sizeStep + 1);
export const sizeMS = sizeUnit * sizeStep;
export const size = sizeUnit * sizeStep;
export const sizeSM = sizeUnit * (sizeStep - 1);
export const sizeXS = sizeUnit * (sizeStep - 2);
export const sizeXXS = sizeUnit * (sizeStep - 3);
export const controlHeightSM = controlHeight * 0.75;
export const controlHeightXS = controlHeight * 0.5;
export const controlHeightLG = controlHeight * 1.25;
export const borderRadiusXS = 2;
export const borderRadiusSM = 4;
export const borderRadiusLG = 8;
export const borderRadiusOuter = 4;
export const colorText = `rgba(0,0,0, 0.88)`;
export const colorTextSecondary = `rgba(0,0,0, 0.65)`;
export const colorTextTertiary = `rgba(0,0,0, 0.55)`;
export const colorTextQuaternary = `rgba(0,0,0, 0.45)`;
export const colorFill = `rgba(0,0,0, 0.2)`;
export const colorFillSecondary = `rgba(0,0,0, 0.08)`;
export const colorFillTertiary = `rgba(0,0,0, 0.037)`;
export const colorFillQuaternary = `rgba(0,0,0, 0.03)`;
export const colorBgContainer = colorBgBase;
export const colorBgLayout = "#f5f5f5";
export const colorBgElevated = colorBgBase;
export const colorBgSpotlight = geekblue6;
export const colorBorder = `rgba(0,0,0, 0.45)`;
export const colorBorderSecondary = `rgba(0,0,0, 0.06)`;
export const colorSplit = `rgba(0,0,0, 0.15)`;
export const colorPrimaryBg = geekblue1;
export const colorPrimaryBgHover = geekblue2;
export const colorPrimaryBorder = geekblue3;
export const colorPrimaryBorderHover = geekblue4;
export const colorPrimaryHover = geekblue5;
export const colorPrimaryActive = geekblue7;
export const colorPrimaryTextHover = geekblue8;
export const colorPrimaryText = geekblue9;
export const colorPrimaryTextActive = geekblue10;
export const colorSuccessBg = green1;
export const colorSuccessBgHover = green2;
export const colorSuccessBorder = green3;
export const colorSuccessBorderHover = green4;
export const colorSuccessHover = green5;
export const colorSuccessActive = green7;
export const colorSuccessTextHover = green8;
export const colorSuccessText = green9;
export const colorSuccessTextActive = green10;
export const colorWarningBg = yellow1;
export const colorWarningBgHover = yellow2;
export const colorWarningBorder = yellow3;
export const colorWarningBorderHover = yellow4;
export const colorWarningHover = yellow5;
export const colorWarningActive = yellow7;
export const colorWarningTextHover = yellow8;
export const colorWarningText = yellow9;
export const colorWarningTextActive = yellow10;
export const colorErrorBg = red1;
export const colorErrorBgHover = red2;
export const colorErrorBorder = red3;
export const colorErrorBorderHover = red4;
export const colorErrorHover = red6;
export const colorErrorActive = red8;
export const colorErrorTextHover = red8;
export const colorErrorText = red9;
export const colorErrorTextActive = red10;
export const colorInfoBg = blue1;
export const colorInfoBgHover = blue2;
export const colorInfoBorder = blue3;
export const colorInfoBorderHover = blue4;
export const colorInfoHover = blue5;
export const colorInfoActive = blue7;
export const colorInfoTextHover = blue8;
export const colorInfoText = blue9;
export const colorInfoTextActive = blue10;
export const colorBgMask = "rgba(0, 0, 0, 0.45)";
export const stepsDotSize = controlHeight / 4;
export const stepsCurrentDotSize = controlHeightLG / 4;
export const rateStarSize = controlHeightLG * 0.5;
// Alias
export const colorFillContent = colorFillSecondary;
export const colorFillContentHover = colorFill;
export const colorFillAlter = colorFillTertiary;
export const colorBgContainerDisabled = colorFillTertiary;
export const colorBorderBg = colorBgContainer;
export const colorTextPlaceholder = colorTextTertiary;
export const colorTextDisabled = colorTextQuaternary;
export const colorTextHeading = colorText;
export const colorTextLabel = colorTextSecondary;
export const colorTextDescription = colorTextTertiary;
export const colorBgTextHover = colorFillSecondary;
export const colorBgTextActive = colorFill;
export const colorIcon = colorText;
export const colorIconHover = colorText;
export const colorLink = colorPrimary;
export const colorLinkHover = colorPrimaryHover;
export const colorLinkActive = colorPrimaryActive;
export const colorHighlight = colorErrorHover;
export const controlOutline = colorPrimaryBg;
export const colorWarningOutline = colorWarningBg;
export const colorErrorOutline = colorErrorBg;
/** IMPORTANT: If used, make sure to transform it to rem */
export const fontSizeSM = 12;
/** IMPORTANT: If used, make sure to transform it to rem */
export const fontSizeLG = 16;
/** IMPORTANT: If used, make sure to transform it to rem */
export const fontSizeXL = 20;
/** IMPORTANT: If used, make sure to transform it to rem */
export const fontSizeIcon = 12;
/** IMPORTANT: If used, make sure to transform it to rem */
export const fontSizeHeading1 = 38;
/** IMPORTANT: If used, make sure to transform it to rem */
export const fontSizeHeading2 = 30;
/** IMPORTANT: If used, make sure to transform it to rem */
export const fontSizeHeading3 = 24;
/** IMPORTANT: If used, make sure to transform it to rem */
export const fontSizeHeading4 = 20;
/** IMPORTANT: If used, make sure to transform it to rem */
export const fontSizeHeading5 = 16;
export const fontWeightNormal = 400;
export const fontWeightStrong = 600;
export const controlLineWidth = lineWidth;
export const controlOutlineWidth = lineWidth * 2;
export const controlItemBgHover = colorFillTertiary;
export const controlItemBgActive = colorPrimaryBg;
export const controlItemBgActiveHover = colorPrimaryBgHover;
export const controlInteractiveSize = controlHeight / 2;
export const controlItemBgActiveDisabled = colorFill;
export const controlTmpOutline = colorFillQuaternary;
export const opacityLoading = 0.65;
export const padding = size;
export const paddingMD = sizeMD;
export const paddingSM = sizeSM;
export const paddingXS = sizeXS;
export const paddingXXS = sizeXXS;
export const paddingLG = sizeLG;
export const paddingXL = sizeXL;
export const paddingXXL = sizeXXL;
export const margin = size;
export const marginSM = sizeSM;
export const marginXS = sizeXS;
export const marginXXS = sizeXXS;
export const marginLG = sizeLG;
export const marginXL = sizeXXL;
export const controlPaddingHorizontal = 12;
export const controlPaddingHorizontalSM = 8;
export const fontWeightItalic = 300;
export const paddingContentHorizontalLG = sizeLG;
export const paddingContentVerticalLG = sizeMS;
export const paddingContentHorizontal = sizeMS;
export const paddingContentVertical = sizeSM;
export const paddingContentHorizontalSM = size;
export const paddingContentVerticalSM = sizeXS;
export const boxShadow = "0px 1px 2px 0px rgba(0,0,0,0.03), 0px 1px 6px -1px rgba(0,0,0,0.02), 0px 2px 4px 0px rgba(0,0,0,0.02)";
export const boxShadowSecondary = "0px 6px 16px 0px rgba(0,0,0,0.08), 0px 3px 6px -4px rgba(0,0,0,0.12), 0px 9px 28px 8px rgba(0,0,0,0.05)";
export const boxShadowCard = "0px 1px 2px -2px rgba(0,0,0,0.16), 0px 3px 6px 0px rgba(0,0,0,0.12), 0px 5px 12px 4px rgba(0,0,0,0.09)";
export const colorItemText = `rgba(255,255,255, 0.65)`;
export const colorItemTextDisabled = `rgba(255,255,255, 0.25)`;
export const focusPrimary = `0px 0px 0px 2px ${colorPrimaryBg}`;
export const focusError = `0px 0px 0px 2px ${colorErrorBg}`;
export const focusWarning = `0px 0px 0px 2px ${colorWarningBg}`;
export const segmentedBgColorSelected = "#ffffff";
export const segmentedGroupBg = colorFillTertiary;
export const colorMenuDarkBg = "#001529";
export const colorMenuSubItemBg = "#000c17";
export const boxShadowButtonSolid = `0px ${controlOutlineWidth} 0px 0px ${controlTmpOutline}`;
export const paddingTooltipContentVertical = paddingSM / 2;
export const lineWidthFocus = lineWidth * 4;
